import {lifecycle} from 'recompose';

export default lifecycle({

  componentDidUpdate() {
  },

  componentDidMount() {
    this.props.listUsers();
    this.props.loadCareUnits();
    this.props.loadOpticians();
  }

});